module.exports = __webpack_public_path__ + "static/media/productDividing.da7daa96.png";